import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type TimelineEntidade = 'lead' | 'pedido' | 'cliente' | 'mensagem';

export interface TimelineEvent {
  id: string;
  cnpj: string;
  entidade: TimelineEntidade;
  entidade_id: string;
  tipo: string;
  descricao: string | null;
  campo: string | null;
  de: any;
  para: any;
  motivo: string | null;
  payload: any;
  created_at: string;
  usuario_id: string | null;
  user_nome: string | null;
  icone: string | null;
  cor: string | null;
  destaque: boolean | null;
  cliente_razao_social: string | null;
  cliente_nome_fantasia: string | null;
  pedido_id: string | null;
  lead_id: string | null;
  cliente_id: string | null;
  triagem_id: string | null;
  lead_numero: number | null;
  numero_pedido: number | null;
}

interface UseTimelineUnificadaOptions {
  cnpj: string | null | undefined;
  clienteId?: string | null;
  /** Lead CPF sem cliente: não tem CNPJ nem cliente, a linha do tempo é a do lead.
   *  Vai pelo número do lead e não pelo lead_id: pelo número a view usa o índice
   *  (0,6 ms); pelo lead_id varre o movimento inteiro (1,1 s). */
  leadNumero?: number | null;
  limit?: number;
  enabled?: boolean;
}

export function useTimelineUnificada({
  cnpj,
  clienteId,
  leadNumero,
  limit = 200,
  enabled = true,
}: UseTimelineUnificadaOptions) {
  return useQuery<TimelineEvent[]>({
    queryKey: ['timeline-unificada', cnpj, clienteId, leadNumero, limit],
    queryFn: async () => {
      if (!cnpj && !clienteId && !leadNumero) return [];

      const base = supabase.from('vw_timeline_unificada').select('*');
      const filtrada = cnpj ? base.eq('cnpj', cnpj)
        : clienteId ? base.eq('cliente_id', clienteId)
        : base.eq('lead_numero', leadNumero!);
      const { data, error } = await filtrada
        .order('created_at', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return (data || []) as TimelineEvent[];
    },
    enabled: enabled && !!(cnpj || clienteId || leadNumero),
    staleTime: 2 * 60 * 1000,
  });
}
